import { APP_KEY_BLOWFISH2 } from "@ipru-common/constants/SiteConstants";
import {
  getCookie,
  readQueryParams,
  // setCookie,
  setLocalStorage,
  getCurrentProductFromMeta,
  getCurrentEventName,
  getNetCorePageInputs,
  isCustomSavingPage,
  getPersonaName,
} from "@ipru-common/utils/CommonFunctions";
import useBlowFish from "@ipru-common/hooks/useBlowFish";
import {
  COOKIE_NAME,
  NETCORE_NAME_IPS_DROP,
  NETCORE_NAME_IPS_DROP_LANG,
  // PAGE_STEPS,
  PRODUCT_KEYS,
} from "@ipru-common/constants/products";
import { NET_CORE_EVENT_PARAM_LIST } from "@ipru-common/constants/NetCoreConstant";
import { OPTION_VALUES } from "@ipru-common/constants/InputValues";
import GlobalStore from "@ipru-common/store/GlobalStore";
import { CurrentProduct } from "shared-library";

const { encryptBlowfish } = useBlowFish({ key: APP_KEY_BLOWFISH2 });
const shouldEncryptQData = () => {
  return [PRODUCT_KEYS.IPS, PRODUCT_KEYS.PNG, PRODUCT_KEYS.SIGNATURE_ASSURE, PRODUCT_KEYS.SIP_PLUS].includes(
    getCurrentProductFromMeta()
  );
};
const PrefillJson = (data) => {
  const { calculatorFormData, currentPageStep } = GlobalStore.getSnapshot();

  const PrefillUserJson = { ...data };

  const { PAGENAME } = getCurrentEventName(data?.isEnglish || data?.isenglish, currentPageStep, getPersonaName());

  PrefillUserJson.gaid = getCookie("GA_VisitorID") || "GAIDnotFound";

  const queryParams = readQueryParams();
  PrefillUserJson.pagename = PAGENAME;
  PrefillUserJson.pan = getCookie("PAN") || ""; // Check
  PrefillUserJson.uid = parseInt(queryParams.get("UID")) || "";

  let cookieJson = {};
  for (var key in PrefillUserJson) {
    if (PrefillUserJson[key] !== undefined && PrefillUserJson[key] !== null) {
      if (key !== "annualincome" && key !== "annual_income") {
        PrefillUserJson[key] = PrefillUserJson[key].toString();
      }
      if (key != "MobileNo" || key != "EmailId" || key != "mobileno" || key != "emailid") {
        cookieJson[key] = PrefillUserJson[key];
      }
    }
  }

  const qData = getNetCorePageInputs(calculatorFormData);
  const encodedQData = shouldEncryptQData() ? encryptBlowfish(JSON.stringify(qData)) : cookieJson?.qdata || "";
  const encodedQdataCookie = {
    ...cookieJson,
    qdata: encodedQData,
  };
  return encodedQdataCookie;
};
export const CreateCookie = (data) => {
  try {
    let cookieJson = PrefillJson(data);
    let Enc_UserData1 = JSON.stringify(cookieJson);

    setLocalStorage(`${COOKIE_NAME[getCurrentProductFromMeta()]}`, encryptBlowfish(Enc_UserData1));
  } catch (e) {
    console.log("Function Error: CreateCookie " + e);
  }
};

const bindValue = (data, keys) => {
  let result = {};
  keys?.forEach((key) => {
    result[key] = data?.[key] || "";
  });

  return result;
};

export const netCoreEvent = (data, callFeedbackApi) => {
  const { currentPageStep, calculatorFormData } = GlobalStore.getSnapshot();

  try {
    let cookieJson = PrefillJson(data);

    const qData = getNetCorePageInputs(calculatorFormData);
    const encodedQData = encryptBlowfish(JSON.stringify(qData));
    cookieJson = {
      ...cookieJson,
      qdata: CurrentProduct?.getProductNetCoreQData?.() ?? encodedQData,
    };

    // let Enc_UserData1 = JSON.stringify(cookieJson);

    // setLocalStorage(${COOKIE_NAME[getCurrentProductFromMeta()]}, encryptBlowfish(Enc_UserData1));
    // const { NETCORE_NAME } = getCurrentGamoogaEventName(data?.isEnglish || data?.isenglish, currentPageStep);
    let { NETCORE_NAME, NETCORE_NAME_CUSTOM_SAVINGS_QUOTE } = getCurrentEventName(
      data?.isEnglish || data?.isenglish,
      currentPageStep,
      getPersonaName()
    );
    NETCORE_NAME = isCustomSavingPage()
      ? NETCORE_NAME_CUSTOM_SAVINGS_QUOTE
      : (CurrentProduct?.getProductNetcoreEvent?.() ?? NETCORE_NAME);

    let eventData = {};
      const keyName = NET_CORE_EVENT_PARAM_LIST[NETCORE_NAME];
      if (keyName) {
        eventData = bindValue(CurrentProduct?.netcoreMapper ? CurrentProduct?.netcoreMapper() : cookieJson, keyName);
      }    

    try {
      if (
        (NETCORE_NAME === NETCORE_NAME_IPS_DROP || NETCORE_NAME === NETCORE_NAME_IPS_DROP_LANG) &&
        data?.["appno"] === "OB11223344"
      ) {
        return;
      }
      if (data?.["trai_flag"] === OPTION_VALUES.Y_YES) {
        const encryptedData = window.smartech("encrypt", eventData);

        const mobile =
          cookieJson?.nri === OPTION_VALUES.NRI_YES
            ? `${cookieJson?.countrycode}${cookieJson?.mobileno || cookieJson?.mobile}`
            : cookieJson?.mobileno || cookieJson?.mobile;

        const contactData = window.smartech("encrypt", { "pk^mobile": mobile, email: cookieJson?.emailid || cookieJson?.email_id });

        const mobileNumber = window.smartech("encrypt", mobile);

        console.log(
          eventData,
          "netCoreEventData",
          CurrentProduct?.getProductNetcoreEvent?.() || NETCORE_NAME,
          "NETCORE_NAME",
          encryptedData && contactData && mobileNumber ? "encrypted" : "something undefined",
          "encryptedData"
        );

        if (encryptedData && contactData && mobileNumber) {
          window.dataLayer.push({
            event: CurrentProduct?.getProductNetcoreEvent?.() || NETCORE_NAME,
            payload: encryptedData,
            mobile: mobileNumber,
            identifier: contactData,
          });
          if (callFeedbackApi)
            callFeedbackApi({ ...calculatorFormData, q1: NETCORE_NAME });
        }
      }
    } catch (e) {
      console.log("Error: Netcore " + e);
    }
  } catch (e) {
    console.log("Function Error: Netcore " + e);
  }
};
